import { ShapeKind, FontType } from '../../drawing/types';
import TextboxUIAction from '../../actions/ui/TextboxUIAction';
import { Color } from '../../types/color';

export type TextboxType = ShapeKind.Sticky | ShapeKind.Balloon | ShapeKind.None;

interface TextboxToolState {
  fillColor: Color;
  lineColor: Color;
  fontType: FontType;
  fontSize: number;
  lineHeight: number;
  padding: number;
  textColor: Color;
  type: TextboxType;
}

export interface TextboxState {
  toolSettings: TextboxToolState[];
  selected: number;
}

export function initTextboxUIState(): TextboxState {
  return {
    toolSettings: [{
      fillColor: Color.White,
      lineColor: Color.Black,
      fontType: FontType.Gothic,
      fontSize: 100,
      lineHeight: 1,
      padding: 1,
      textColor: Color.Black,
      type: ShapeKind.Sticky,
    }, {
      fillColor: Color.White,
      lineColor: Color.Black,
      fontType: FontType.Gothic,
      fontSize: 100,
      lineHeight: 1,
      padding: 1,
      textColor: Color.Black,
      type: ShapeKind.Sticky,
    }, {
      fillColor: Color.White,
      lineColor: Color.Black,
      fontType: FontType.Gothic,
      fontSize: 100,
      lineHeight: 1,
      padding: 1,
      textColor: Color.Black,
      type: ShapeKind.Sticky,
    }],
    selected: 0,
  };
}

export const textbox = (
  state: TextboxState,
  action: TextboxUIAction.Action,
): TextboxState => {
  switch (action.type) {
    case TextboxUIAction.ActionType.SELECT_TOOL: {
      return { ...state, selected: action.selected };
    }
    case TextboxUIAction.ActionType.SET_FILL_COLOR: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].fillColor = action.fillColor;

      return { ...state, toolSettings: newToolSettings };
    }
    case TextboxUIAction.ActionType.SET_LINE_COLOR: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].lineColor = action.lineColor;

      return { ...state, toolSettings: newToolSettings };
    }
    case TextboxUIAction.ActionType.SET_FONT_TYPE: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].fontType = action.fontType;

      return { ...state, toolSettings: newToolSettings };
    }
    case TextboxUIAction.ActionType.SET_FONT_SIZE: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].fontSize = action.fontSize;

      return { ...state, toolSettings: newToolSettings };
    }
    case TextboxUIAction.ActionType.SET_LINE_HEIGHT: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].lineHeight = action.lineHeight;

      return { ...state, toolSettings: newToolSettings };
    }
    case TextboxUIAction.ActionType.SET_PADDING: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].padding = action.padding;

      return { ...state, toolSettings: newToolSettings };
    }
    case TextboxUIAction.ActionType.SET_TEXT_COLOR: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].textColor = action.textColor;

      return { ...state, toolSettings: newToolSettings };
    }
    case TextboxUIAction.ActionType.SET_TOOL_TYPE: {
      const newToolSettings = [...state.toolSettings];
      newToolSettings[action.selected].type = action.textboxType;

      return { ...state, toolSettings: newToolSettings };
    }
  }
};
